import React from 'react';
import { FaLightbulb, FaMoon, FaThermometerHalf, FaBolt } from 'react-icons/fa';

const RotaFrequency = () => {  
  const frequency = [
    {
      icon: FaLightbulb,
      title: "Opening Check",
      frequency: 'Daily',
      badgeColor: 'bg-emerald-50 text-emerald-700 border-emerald-100',
      bgColor: 'bg-amber-500' 
    },
    {
      icon: FaMoon,
      title: "Closing Check",
      frequency: 'Daily',
      badgeColor: 'bg-emerald-50 text-emerald-700 border-emerald-100',
      bgColor: "bg-blue-500"
    },
    {
      icon: FaThermometerHalf,
      title: "Food Temperature Log",
      frequency: 'Daily',
      badgeColor: 'bg-emerald-50 text-emerald-700 border-emerald-100',
      bgColor : "bg-green-500"
    },
    {
      icon: FaBolt,
      title: "PAT Inspection",
      frequency: 'Monthly',
      badgeColor: 'bg-indigo-50 text-indigo-700 border-indigo-100',
      bgColor : "bg-orange-500"
    },
  ];

  return (
    <section className="mt-8 p-4 bg-white border border-slate-100 rounded-xl shadow-sm">
      <div className="mb-4">
        <h2 className="text-xl font-bold text-slate-800">Checks & Frequencies</h2>
      </div>

      <div className="grid grid-cols-1 gap-4">
        {frequency.map((item, index) => {
          const IconComponent = item.icon;
          return (
            <div 
              key={index}
              className="flex items-center justify-between p-4 bg-white border border-slate-100 rounded-xl shadow-sm hover:border-slate-200 hover:shadow transition-all duration-200"
            >
              <div className="flex items-center gap-4">
                {/* Fixed Template Literal Syntax Here */}
                <div className={`p-3 ${item.bgColor} rounded-lg text-white flex items-center justify-center`}>
                  <IconComponent className="w-5 h-5" />
                </div>
                <div>
                  <h3 className="font-semibold text-slate-700 text-sm md:text-base">
                    {item.title}
                  </h3>
                </div>
              </div>

              <span className={`px-2.5 py-1 text-xs font-semibold rounded-full border ${item.badgeColor}`}>
                {item.frequency}
              </span>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default RotaFrequency;
